export default __webpack_public_path__ + "static/media/tesla.a4079404.jpg";